var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showLoader)?_c('div',{staticClass:"overlay"},[_c('breeding-rhombus-spinner',{attrs:{"animation-duration":1000,"size":60,"color":'#df1e75'}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }